<template>

  <input
    type="text"
    class="form-control"
    :value="value"
    @input="change"
    @keyup.up="pressUp"
    @keyup.down="pressDown"
    @keyup.enter="pressEnter"
    :placeholder="placeholder">

</template>

<script>
let interval = null

export default {
  name: 'InputKeyword',
  props: {
    'value': {
      type: String,
      default: ''
    },
    'placeholder': {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    change (event) {
      var newValue = event.target.value

      clearTimeout(interval)
      interval = setTimeout(() => {
        this.$emit('input', newValue)
      }, 500)
    },
    pressUp (e) {
      this.$emit('pressUp', e)
    },
    pressDown (e) {
      this.$emit('pressDown', e)
    },
    pressEnter (e) {
      this.$emit('pressEnter', e)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/InputKeyword.vue